"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BaseSetting = _interopRequireDefault(require("./BaseSetting.vue"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _config = require("@/components/FormGenerator/components/generator/config");
var _SearchItem = _interopRequireDefault(require("./components/SearchItem.vue"));
var _BannerItem = _interopRequireDefault(require("./components/BannerItem.vue"));
var _NavItem = _interopRequireDefault(require("./components/NavItem.vue"));
var _ImgnavItem = _interopRequireDefault(require("./components/ImgnavItem.vue"));
var _ImgactItem = _interopRequireDefault(require("./components/ImgactItem.vue"));
var _MarketItem = _interopRequireDefault(require("./components/MarketItem.vue"));
var _PintuanItem = _interopRequireDefault(require("./components/PintuanItem.vue"));
var _MovieItem = _interopRequireDefault(require("./components/MovieItem.vue"));
var _FormtextItem = _interopRequireDefault(require("./components/FormtextItem.vue"));
var _Offset = _interopRequireDefault(require("./components/Offset.vue"));
var _CityLocation = _interopRequireDefault(require("./components/CityLocation.vue"));
var _TipsText = _interopRequireDefault(require("./components/TipsText.vue"));
var _RightsExchangeItem = _interopRequireDefault(require("./components/RightsExchangeItem.vue"));
var _Raffle = _interopRequireDefault(require("./components/Raffle.vue"));
var _Rich = _interopRequireDefault(require("./components/Rich.vue"));
var _Msg = _interopRequireDefault(require("./components/Msg.vue"));
var _RealNameAuthItem = _interopRequireDefault(require("./components/RealNameAuthItem.vue"));
var _ActivityGoodsItem = _interopRequireDefault(require("./components/ActivityGoodsItem.vue"));
var actievApi = _interopRequireWildcard(require("@/api/activityListApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//插件引入
var _default2 = exports.default = {
  components: {
    BaseSetting: _BaseSetting.default,
    draggable: _vuedraggable.default,
    SearchItem: _SearchItem.default,
    MarketItem: _MarketItem.default,
    BannerItem: _BannerItem.default,
    NavItem: _NavItem.default,
    ImgnavItem: _ImgnavItem.default,
    ImgactItem: _ImgactItem.default,
    PintuanItem: _PintuanItem.default,
    MovieItem: _MovieItem.default,
    FormtextItem: _FormtextItem.default,
    Offset: _Offset.default,
    CityLocation: _CityLocation.default,
    TipsText: _TipsText.default,
    RightsExchangeItem: _RightsExchangeItem.default,
    Raffle: _Raffle.default,
    Rich: _Rich.default,
    Msg: _Msg.default,
    RealNameAuthItem: _RealNameAuthItem.default,
    ActivityGoodsItem: _ActivityGoodsItem.default
  },
  props: {
    componentLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    detailInfos: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      formConf: _config.formConf,
      showType: 1,
      baseForm: {},
      tabOptionList: [],
      baseConfigInfo: {},
      activeName: 0
    };
  },
  watch: {
    // componentLists: {
    //     handler(val=[]) {
    //         this.tabOptionList=JSON.parse(JSON.stringify(val));
    //     },
    //     deep: true,
    //     immediate: true,
    // },
    detailInfos: {
      handler: function handler() {
        var detailInfos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var config = detailInfos.config,
          _detailInfos$componen = detailInfos.componentList,
          componentList = _detailInfos$componen === void 0 ? [] : _detailInfos$componen;
        this.baseConfigInfo = config;
        console.log('componentList', componentList);
        this.tabOptionList = componentList;
        // TODO 初次进来
        // this.refreshActName(0);
      },
      immediate: true,
      deep: true
    },
    submitDates: {
      handler: function handler() {
        // 实时预览
        this.$emit('showPreviewSkin', this.submitDates);
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    submitDates: function submitDates() {
      return {
        config: this.baseConfigInfo,
        componentList: this.tabOptionList
      };
    }
  },
  mounted: function mounted() {
    this.rowDrop(); //初始化拖拽方法
  },
  methods: {
    addView: function addView() {
      var _this$tabOptionList, _this$tabOptionList3;
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 客服组件（showType17）全局仅允许一个
      if (Number(item.showType) === 17) {
        var exists = (this.tabOptionList || []).some(function (c) {
          return Number(c.showType) === 17;
        });
        if (exists) {
          this.$message.warning('不能设置多个客服组件');
          return;
        }
      }
      this.showType = 2;
      var obj = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(item))), {}, {
        itemKey: actievApi.generateRandomString(8)
      });
      if (!this.tabOptionList || !((_this$tabOptionList = this.tabOptionList) !== null && _this$tabOptionList !== void 0 && _this$tabOptionList.length)) {
        this.tabOptionList = [obj];
      } else {
        var _this$tabOptionList2;
        (_this$tabOptionList2 = this.tabOptionList) === null || _this$tabOptionList2 === void 0 ? void 0 : _this$tabOptionList2.push(obj);
      }
      ;
      this.refreshActName(((_this$tabOptionList3 = this.tabOptionList) === null || _this$tabOptionList3 === void 0 ? void 0 : _this$tabOptionList3.length) - 1);
    },
    refreshActName: function refreshActName(i) {
      var _this$tabOptionList4;
      var item = (_this$tabOptionList4 = this.tabOptionList) === null || _this$tabOptionList4 === void 0 ? void 0 : _this$tabOptionList4[i];
      this.activeName = (item === null || item === void 0 ? void 0 : item.itemKey) || 0;
    },
    //拖拽方法
    rowDrop: function rowDrop() {
      var el = document.querySelector(".tabSign .el-tabs__nav"); //找到想要拖拽的那一列
      var _this = this;
      _sortablejs.default.create(el, {
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
            oldIndex = _ref.oldIndex;
          // 有时候位置会变为0，这时候默认改为1
          var newIndex2 = newIndex || 1;
          var oldIndex2 = oldIndex || 1;
          var currRow = JSON.parse(JSON.stringify(_this.tabOptionList[oldIndex2 - 1]));
          _this.tabOptionList.splice(oldIndex2 - 1, 1); // 删除旧的
          _this.tabOptionList.splice(newIndex2 - 1, 0, currRow); // 存入新的
          // 下面写自己的逻辑
        }
      });
    },
    removeTab: function removeTab(e, i) {
      var _this$tabOptionList5,
        _this2 = this;
      e.stopPropagation();
      e.preventDefault();
      (_this$tabOptionList5 = this.tabOptionList) === null || _this$tabOptionList5 === void 0 ? void 0 : _this$tabOptionList5.splice(i, 1);
      setTimeout(function () {
        var _this2$tabOptionList;
        _this2.refreshActName(((_this2$tabOptionList = _this2.tabOptionList) === null || _this2$tabOptionList === void 0 ? void 0 : _this2$tabOptionList.length) - 1);
      }, 100);
    }
  }
};